import { HTML_PREVIEW_SANDBOX, htmlPreviewDocument } from './artifactFiles';

// D14: the only place an HTML file is rendered in the CRM. `srcdoc` (never the
// file's URL) + `sandbox="allow-scripts"`: an opaque origin with no access to
// the CRM's cookies, storage or DOM, and no popups, forms or top navigation.
// The CSP the chat API injected at save time also blocks fetch and remote
// images, and the report runs inside the stored wrapper (htmlPreviewDocument),
// whose frame-src 'none' stops it navigating away with its data. Never add
// allow-same-origin: next to allow-scripts it lets the page remove its own
// sandbox.
export const HtmlPreviewFrame = ({
  html,
  title,
}: {
  html: string;
  title: string;
}) => (
  <iframe
    title={title}
    srcDoc={htmlPreviewDocument(html)}
    sandbox={HTML_PREVIEW_SANDBOX}
    referrerPolicy="no-referrer"
    css={{
      display: 'block',
      width: '100%',
      height: '100%',
      border: 0,
      backgroundColor: '#fff',
    }}
  />
);
